import React from 'react';
import { View } from 'react-native';
import { useTheme } from 'styled-components/native';
import { FlexBlockWrapped, MetricStackTitle, ShinyBlockOuter, ShinyBody, ShinyHeading, BasicText as Text } from './Styles'

export default function Compliance({portalData, currentMonth}){
    const theme = useTheme();

    let thisMonth = null;

    if (theme.screen == 'desktop'){
    }

 
    return <View>
        <FlexBlockWrapped>
            <ShinyBlockOuter flex={2} minHeight={400}>
                    <ShinyHeading>
                        <MetricStackTitle>{"Compliance"}</MetricStackTitle>
                    </ShinyHeading>
                    <ShinyBody>
                        <Text>Compliance Here</Text>
                    </ShinyBody>
                </ShinyBlockOuter>
        </FlexBlockWrapped>
        </View>
}